<template>
  <div>
    <div class="box">
      <i class="back iconfont iconfanhui" @click="$router.push('/')" />
      <div class="login_box">
        <div class="img">
          <img src="../../assets/img/logo.png" alt width="123px" height="43px" />
        </div>
        <div class="login">
          <div class="username inputWrap">
            <label>
              <i class="iconfont iconshouji" />
            </label>
            <input v-model="loginInfo.usename" placeholder="请输入手机号" />
          </div>
          <div class="password inputWrap">
            <label>
              <i class="iconfont iconmima" />
            </label>
            <input v-model="loginInfo.captcha" placeholder="请输入图形验证码" />
            <!-- 获取验证码 -->
            <div style="position:relative">
              <img class="gain" :src="codeImg" @click="getcaptcha()" />
            </div>
          </div>
          <!-- 验证码 -->
          <div class="password inputWrap">
            <label>
              <i class="iconfont iconyanzhengma" />
            </label>
            <input v-model="loginInfo.code" placeholder="请输入手机验证码" />
            <!-- 获取验证码 -->
            <div class="btnWrap">
              <button class="getCode" @click="sendMessage" v-show="show">获取验证码</button>
              <div class="getCode" v-show="!show">{{timers}}</div>
            </div>
          </div>
          <!-- 登录按钮 -->
          <button class="login_btn" @click="login">登录</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { captcha, code, login_mobile } from "../../api/http.js";
export default {
  data() {
    return {
      loginInfo: {
        usename: "",
        code: "",
        captcha_id: "",
        captcha: ""
      },
      values: "获取验证码",
      timers: null,
      timer: 6,
      show: true,
      codeImg: ""
    };
  },
  created() {
    this.getcaptcha();
  },
  methods: {
    timekeeping() {
      //倒计时
      let auth_timer = setInterval(() => {
        //定时器设置每秒递减
        this.timer--; //递减时间
        this.show = false;
        if (this.timer > 0) {
          this.Verification = true; //60s时间结束还原v-show状态并清除定时器
          const tim = this.timer;
          // this.values=tim+"秒后获取"
          this.timers = tim + "秒后获取";
        } else if (this.timer == 0) {
          clearInterval(auth_timer);
          this.show = true;
          this.timer = 60;
        }
      }, 1000);
    },
    sendMessage() {
      //获取验证码
      if (!/^1((3|5|8){1}\d{1}|70|99)\d{8}$/.test(this.loginInfo.usename)) {
        this.$toast.fail("手机号错误");
        return;
      }
      if (this.loginInfo.captcha == "") {
        this.$toast.fail("请正确填写图形验证码");
        return;
      }
      this.timekeeping();
      this.getcode();
      // this.mylogin()
    },
    getcaptcha() {
      captcha(20, 50, 101, 3).then(res => {
        // page sortType  sortPrice  category_id  search  wxapp_id
        this.loginInfo.captcha_id = res.data.id;
        this.codeImg = res.data.captcha;
      });
    },
    getcode() {
      code(
        this.loginInfo.usename,
        this.loginInfo.captcha_id,
        this.loginInfo.captcha
      ).then(res => {
        //page sortType  sortPrice  category_id  search  wxapp_id
        if (res.code == 0) {
          this.$toast.fail("验证码获取失败");
        } else if (res.code == 10500) {
          this.$toast.fail("图形验证码错误");
        }
      });
    },
    login() {
      if (!/^1((3|5|8){1}\d{1}|70|99)\d{8}$/.test(this.loginInfo.usename)) {
        this.$toast.fail("手机号错误");
        return;
      }
      if (!/\d{4,6}/.test(this.loginInfo.code)) {
        this.$toast.fail("请正确填写短信验证码");
        return;
      }
      login_mobile(this.loginInfo.usename, this.loginInfo.code).then(res => {
        if (res.code == 1) {
          localStorage.setItem("login_token", res.data.token);
          this.$router.replace("/");
        } else if (res.code == 0) {
          this.$toast.fail(res.msg);
        }
      });
    },
    msg() {
      this.$toast("暂未开通此接口");
    }
  },
  mounted() {}
};
</script>
<style lang="scss" scoped>
.box {
  display: flex;
  height: 100vh;
  background: url("../../assets/img/login.jpg");
  .back {
    position: fixed;
    top: 0px;
    left: 0px;
    height: 60px;
    width: 60px;
    text-align: center;
    line-height: 60px;
    font-size: 24px;
    z-index: 3;
    color: #fff;
  }
  .login_box {
    width: 363px;
    // height:384px;
    background: rgba(255, 255, 255, 1);
    // background: pink;
    box-shadow: -9px 11px 24px 3px rgba(100, 100, 100, 0.14);
    border-radius: 6px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 90px;
    padding-top: 40px;
    padding-bottom: 29px;
    .img {
      height: 43px;
      margin-bottom: 28px;
      text-align: center;
    }
    .login {
      width: 320px;
      margin: auto;
      .inputWrap {
        display: flex;
        height: 45px;
        margin-bottom: 15px;
        input {
          border: 0px;
          border-bottom: 1px solid #dcdcdc;
          border-radius: 0px;
          font-size: 12px;
          height: 44px;
          padding: 0px 5px;
        }
        label {
          display: block;
          height: 44px;
          width: 45px;
          line-height: 44px;
          text-align: center;
          color: #dcdcdc;
          border-bottom: 1px solid #dcdcdc;
        }
      }
      .username {
        input {
          width: 275px;
        }
      }
      .password {
        input {
          width: 175px;
        }
        .gain {
          width: 100px;
          height: 31px;
          padding: 6.5px 0px;
          border-bottom: 1px solid #dcdcdc;
        }
        .btnWrap {
          border-bottom: 1px solid #dcdcdc;
          height: 44px;
          .getCode {
            width: 100px;
            font-size: 12px;
            border-radius: 15px;
            height: 30px;
            border: 0px;
            background: #c9a864;
            color: #fff;
            text-align: center;
            line-height: 30px;
          }
        }
      }
      .login_btn{
        height: 42px;
        width: 100%;
         background: #c9a864;
         border: 0px;
         color: #fff;
         font-size: 12px;
         border-radius: 21px;
      }
    }
  }
}
</style>


